<template>
        <div id='altermobile'>
              <NavTop title='更换手机号'/>
              <div class='content'>
                 <div class="row">
                      <div class="label">验证码</div>
                      <div class="maininput"><input placeholder="请输入验证码" type="number" v-model='code'/></div>
                      <div class="yzm_btn" @click="getCode(3)">获取验证码</div>
                 </div>
                 <div class="row">
                       <div class="label">新手机号码</div>
                       <div class="maininput"><input placeholder="请输入新手机号码" type="number" v-model='newmobile'/></div>
                 </div>
                 <div class="submitbtn_out">
                        <div class="submitbtn" @click="changeMobile">提交</div>
                 </div>
              </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
export default {
  data(){
      return{
        code:'',
        oldmobile:'',
        newmobile:''
      }
  },  
  name: 'altermobile',
  created(){
    this.$post("/user/getUserInfo",{}).then((data)=>{
            if(data.result.success){
              this.oldmobile=data.result.info.mobile
            }
        })
  },
  methods:{
    getCode(type){
         if(this.oldmobile==''|| isNaN(this.oldmobile)){
            this.$toast("手机号码不正确")
            return false
         } 
         this.$post("/sms/getCode",{mobile:this.oldmobile,type:type}).then((data)=>{
              this.$toast(data.result.info)
         })
    },
    changeMobile(){
        if(this.code==''||isNaN(this.code)){
          this.$toast("验证码输入有误");return false;
        } 
        if(this.newmobile==""||isNaN(this.newmobile)){
          this.$toast("手机号码输入有误");return false;
        }
        this.$post("/user/alterMobile",{code:this.code,newmobile:this.newmobile,oldmobile:this.oldmobile}).then((data)=>{
            if(data.result.success){
              this.$toast(data.result.info)
              this.$go("/security")
            }else{
              this.$toast(data.result.info)
            }
        })
    }
  },
  components:{
      NavTop
  }
}
</script>
<style scoped>
#altermobile{background-color:#F6F6F6;min-height: 100vh;}
.content{display: flex;flex-flow: column nowrap;padding: 0.35rem;background-color: #fff;border-radius: 0.2rem;margin: 0 0.25rem;}
.title{font-size:0.5rem;padding: 0.35rem;text-align: left;padding-left: 0.15rem;}
.row{display: flex;flex-flow:row nowrap;border-bottom: 1px solid #e7e7e7;align-items: center;padding: 0.35rem;}
.label{width:2.2rem;text-align: left;font-size:0.35rem;}
.maininput {flex:1 0 50%;}
.maininput input{border: none;outline: none;color:#333;background-color: #fff;width: 100%;font-size:0.35rem;}
.yzm_btn{text-decoration: underline;font-size:0.3rem;color:#333;}
.submitbtn_out{margin-top: 0.65rem;}
.submitbtn{background-color:#ee0a24;color:#fff;;font-size:0.35rem;padding: 0.25rem;border-radius: 0.1rem;}

</style>


